export default {
  'assignAlerts.alertName': 'Alert Name',
  'assignAlerts.selectEventType': 'Select Event Type',
  'assignAlerts.accountActivity.description':
    'Notifies you of transactions matching your criteria post to designated account(s).',
  'assignAlerts.accountBalance.description':
    'Notifies you of  account balance above or below a predefined amount.',
  'assignAlerts.reports.description': 'Notifies you when ERD reports are available.',
  'assignAlerts.achApprovals.description':
    'Notifies you when an ACH batch reaches an "approval required" status.',
  'assignAlerts.positivePay.description':
    'Notifies you of accounts with and without Positive Pay Exceptions.',
  'assignAlerts.wireApprovals.description':
    'Notifies you when a pending Wire Transfer reaches an "approval required" status.',
  'assignAlerts.wiresSent.description':
    'Notifies you when a Wire Transfer is submitted for final processing.',
  'assignAlerts.successMessage': 'Success! New alert {0} added.',
  'assignAlerts.modifyMessage': 'Success! Alert {0} has been modified.',
  'assignAlerts.includePassthru': 'Include Passthru Approval notifications',
  'assignAlerts.availableReports': 'Available Reports',
  'assignAlerts.selectedReports': 'Selected Reports'
};
